import { Cycle } from '../types/sync'
import { useDatabase } from '../composables/database'

type CycleModelReturn = {
  loadCycleData: () => Promise<Cycle>
  writeCycleData: (data: Cycle) => Promise<void>
  clearCycle: () => Promise<void>
}
export const CycleModel = (): CycleModelReturn => {
  const { run, query } = useDatabase()

  const loadCycleData = async () => {
    const sql = `
        SELECT * FROM cycle;
    `
    return await query(sql)
      .catch((error) => console.log(`Error loading cycle: ${error}`))
      .then((cycle) => {
        if (cycle && typeof cycle !== 'undefined' && cycle.length > 0) {
          const data = JSON.parse(cycle[0]['current_cycle_data'])
          return data
        } else {
          return []
        }
      })
  }
  const writeCycleData = async (data: Cycle) => {
    const sql = `
        INSERT OR REPLACE INTO cycle ('id', 'current_cycle_data')
        VALUES (0, ?);
    `
    await run(sql, [JSON.stringify(data)]).catch((error) =>
      console.log(`Error writing cycle data to DB: ${error}`)
    )
  }
  const clearCycle = async () => {
    const sql = `
        DELETE FROM cycle;
    `
    await run(sql, []).catch((error) => {
      console.log(`Error deleting cycles: ${error}`)
    })
  }
  return {
    loadCycleData,
    writeCycleData,
    clearCycle,
  }
}
